<template>
  <div>
    <div class="certificate-demo" v-if="isShow">
      <messageStep :dataForm="dataForm"></messageStep>
      <!-- <div class="acc-bj" v-if="dataForm.step != '00'"></div> -->
      <!--提示-->
      <div
        class="content-front"
        v-if="['01', '02', '03', '04', '05'].includes(dataForm.step)"
      >
        <ab-title title="签约流程">
          <template #subTitle>
              <div class="title-header">
                  <el-button size="mini" @click="signingTutorialDialog = true" style="padding: 5px 8px; float: right" type="primary" plain>
                <!-- <icon-svg name="bofang" style="width:18px; height: 17px; margin-right:4px; float: left"></icon-svg>  -->
                <span style="float: left; margin-top: 2px">签约教程</span> </el-button>
                  <el-button v-if="dataForm.step == '05'" size="mini" @click="downloadDraft" style="padding: 5px 10px; float: right; margin-right: 10px; color: #000" plain>下载协议草稿</el-button>
              </div>
          </template>
          <el-row class="step-title">
            <el-col :span="24">
              <el-steps :active="activeStep">
                <el-step
                  :title="obj.title"
                  v-for="(obj, key) in stepData"
                  :key="key"
                ></el-step>
              </el-steps>
            </el-col>
          </el-row>
        </ab-title>
        <!-- 第一步 -->
        <firstStep :dataForm="dataForm"></firstStep>

        <!-- 第二步 -->
        <twoStep :companyData="companyData" :dataForm="dataForm"></twoStep>
        <!-- 第三步 -->
        <threeStep :dataForm="dataForm"></threeStep>
        <!-- 第四步 -->
        <fourStep :dataForm="dataForm"></fourStep>
        <!-- 第五步 -->
        <fifthStep :dataForm="dataForm" ref="fifthStep"></fifthStep>
      </div>
    </div>
    <el-dialog
      title="签约成功"
      v-model="certificateDialog.show"
      :append-to-body="true"
      width="300px"
      height="300px"
      :before-close="handleClose"
    >
      <div style="text-align: center;">关注服务号，及时获得业务动态</div>
      <img src="../../assets/img/yixiu.jpg" />
    </el-dialog>
    <el-dialog
      title="签约教程"
      v-model="signingTutorialDialog"
      class="signingTutorialDialog"
      :append-to-body="true"
      top="22vh"
      :close-on-click-modal="false"
      destroy-on-close
      width="900px"
    >
      <video v-if="signingTutorialDialog" autoplay controls="controls" src="https://scp-static.oss-cn-shenzhen.aliyuncs.com/prod/template/自助签约视频.mp4">
      </video>
    </el-dialog>
  </div>
</template>

<script>
import messageStep from "./message_step";
import firstStep from "./firstStep";
import twoStep from "./twoStep";
import threeStep from "./threeStep";
import fourStep from "./fourStep";
import fifthStep from "./fifthStep";
export default {
  name: "sign-contract",
  components: {
    messageStep,
    firstStep,
    twoStep,
    threeStep,
    fourStep,
    fifthStep
  },
  data() {
    return {
      signingTutorialDialog: false,
      couponDialog: {
        show: false,
        couponList: []
      },
      dataForm: {},
      stepData: [
        { title: "选择业务", step: "01" },
        { title: "完善信息", step: "02" },
        { title: "确认报价", step: "03" },
        { title: "企业认证", step: "04" },
        { title: "签署协议", step: "05" }
      ],
      companyData: {
        enterpriseName: "",
        enterpriseMail: ""
      },
      isShow: false,
      certificateDialog: {
        show: false
      }
    };
  },
  computed: {
    activeStep() {
      return Number(this.dataForm.step) - 1
    },
    step() {
      return this.$store.state.step
    }
  },
  created() {
    this.getCurClientRegisterStep()
  },
  methods: {
    downloadDraft() {
      this.$refs.fifthStep.downloadDraft()
    },
    getCurClientRegisterStep() {
      this.$get("/crm/clientRegisterStep/getCurClientRegisterStep").then(
        ({ data }) => {
          if (data && data.code == "C0000") {
            // console.log(data.result, '认证状态')
            this.dataForm = data.result
            if (!this.dataForm) {
              this.dataForm = { step: "99" }
            }
            this.$store.commit("SET_STEP", this.dataForm.step);
            switch (this.dataForm.step) {
              case "00": //温馨提示
                this.isShow = true
                break
              case "01": //选择业务
                this.isShow = true
                break
              case "02": //完善信息
                this.companyData.enterpriseName = this.dataForm.enterpriseName
                this.companyData.enterpriseMail = this.dataForm.enterpriseMail
                this.isShow = true
                break
              case "03": //确认报价
                this.isShow = true
                break
              case "04": //企业认证
                this.isShow = true
                break
              case "05": //签署协议
                this.isShow = true
                break
              case "99": //操作完成
                let stepDone = this.$utils.getSessionStorage("stepDone")
                if (stepDone) {
                  setTimeout(() => {
                    //this.certificateDialog.show = true
                    this.$utils.removeSessionStorage("stepDone")
                  }, 200)
                }
              default:
                this.isShow = false
                break
            }
          }
        }
      )
    },
    gotoStep(dataForm) {
      return this.$post("/crm/clientRegisterStep/gotoStep", dataForm).then(
        ({ data }) => {
          if (data && data.code == "C0000") {
            this.dataForm = data.result
          }
        }
      )
    },
    backToStep(step) {
      return this.$get("/crm/clientRegisterStep/backToStep", {
        step: step
      }).then(({ data }) => {
        if (data && data.code == "C0000") {
          this.dataForm = data.result
        }
      })
    }
  }
}
</script>

<style lang="scss">
.signingTutorialDialog{
  .el-dialog__body{
    height: 441px;
    padding: 0;
  }
  video{
    width: 100%;
  }
}
.shareDialog .el-dialog__body {
  min-height: unset !important;
}
.certificate-demo {
  padding-bottom: 60px;
  position: relative;
  //页脚
  .footer {
    position: absolute;
    bottom: 20px;
    border: 0;
    width: 100%;
    margin-left: 0;
    padding-left: 0;
  }
  .quote-form-item{
    // width: 640px;
    .el-form-item__content{
      height: 83px;
      .el-input__wrapper{
        width: 640px;
        height: 60px;
        .el-input__inner{
          height: 60px;
        }
      }
    }
  }
  font-family: "PingFangSC-Regular", "Noto Sans SC";
  font-size: 14px;
    background-color: #fff;
    .title-header{
      margin-right: 10px;
      margin-top: 4px;
      float: right;
      .el-button {
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #fff;
      }
    }
  .acc-bj {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    background-image: url("../../assets/img/client-bj5.jpg");
    background-repeat: no-repeat;
    // background-position: center;
    background-size: cover;
    filter: blur(4px);
    -webkit-filter: blur(4px);
    margin-top: 48px;
  }
  .step-title {
    width: 780px;
    margin: 0 auto;
    background-color: #fff;
  }
  .el-message-box__wrapper {
    position: absolute !important;
    left: 50%;
    margin: 50px 0 0 -244px;
  }
  .el-message-box__btns .el-button {
    width: 100px;
  }
  .el-message-box__title {
    font-size: 14px;
  }
  .content-front {
    // position: fixed;
    left: 0;
    top: 50px;
    width: 100%;
    height: 100%;
    // padding: 10px;
    // background-color: #fff;
    overflow-y: scroll;
    &::-webkit-scrollbar{
        width: 3px;
    }
    .el-steps {
      margin-top: 30px;
    }
    .is-finish,
    .is-process{
      .el-step__icon {
        width: 48px !important;
        height: 48px !important;
        font-size: 19px !important;
        cursor: pointer;
        background-color: #0B7AFF;
        border: 0;
        .el-step__icon-inner{
          color: #F3F8FC;
        }
      }
    }
    .el-step__icon {
      width: 48px !important;
      height: 48px !important;
      font-size: 19px !important;
      cursor: pointer;
      display: block;
      background-color: #F3F8FC;
      border: 0;
      .el-step__icon-inner{
        color: #646668;
      }
    }
    .el-step__icon-inner {
      line-height: 36px !important;
      // font-weight: bold;
      color: #EDF2F6;
      line-height: 35px;
      // font-weight: 600;
      font-size: 14px;
      position: absolute;
      width: 36px;
      height: 36px;
      border: 1px solid #DDDDDD;
      border-radius: 50%;
      top: 6px;
      left: 6px;
    }
    .el-icon-check {
      top: -3px;
      position: relative;
    }
    .el-step.is-horizontal{
      .is-finish,
      .is-process{
        .el-step__line{
          border: 1px dashed #0B7AFF;
          &::before{
            border-left: 10px solid #0B7AFF;
          }
        }
      }
      .el-step__line {
        top: 24px !important;
        border: 1px dashed #e8e8ed;
        position: relative;
        margin-right: 3px !important;
        &::before{
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          right: -3px;
          top: -5.5px;
          border-top: 5px solid transparent;
          border-left: 10px solid #DDDDDD;
          border-bottom: 6px solid transparent;
        }
      }
    }
    .el-step__line-inner {
      border-width: 0px !important;
    }
    .is-horizontal .is-process {
      color: #000000;
      border-color: #000000;
    }
    .el-step__main {
      color: rgba(51, 51, 51, 1);
      .el-step__title {
        display: inline-block;
        text-indent: calc(-50% + 48px);
        font-size: 14px !important;
      }
      .is-wait{
        color: #ccc;
      }
      .is-finish,
      .is-process{
        color: #000;
        // font-weight: 600;
      }
      .el-step__title.is-process{
        font-weight: unset;
      }
    }
  }
  .el-message-box__header {
    background-color: #0068b7 !important;
    .el-message-box__title,
    .el-message-box__close {
      color: #ffffff !important;
    }
  }
  .step-biz-type {
    .el-button--max {
      height: 60px;
      width: 300px;
      margin-bottom: 20px;
      font-size: 14px;
    }
    margin-top: 100px;
    text-align: center;
  }
  .four-step {
    .el-message-box {
      width: 1250px;
    }

    position: initial !important;

    margin-top: 20px;
  }
  .contend-tab {
    table,
    table tr th,
    table tr td {
      border: 1px solid #bebec4;
      font-size: 14px;
    }
    table {
      width: 100%;
      min-height: 10px;
      line-height: 20px;
      border-collapse: collapse;
    }
    td {
      padding: 10px;
    }
    .isCenter {
      text-align: center;
    }
    .isLeft {
      text-align: left;
    }
  }
}
</style>
